/**
 * Demo data for Surgeon Supply Suggestions.
 * Smart preference card update recommendations based on historical OR patterns.
 */

import type { SupplyItem } from './orSyncEngine';

export interface SupplySuggestion {
  id: string;
  procedureName: string;
  cptCode: string;
  caseCount: number;
  currentItem: SupplyItem;
  suggestedItem: SupplyItem;
  patternType: 'never_used' | 'consistent_substitute' | 'quantity_adjust';
  confidencePercent: number;
  estimatedTimeSavedMinutes: number;
  lastCaseDate: string;
}

export const DEMO_SUGGESTIONS: SupplySuggestion[] = [
  {
    id: 'sug-001',
    procedureName: 'Carpal Tunnel Release',
    cptCode: '64721',
    caseCount: 8,
    currentItem: { id: 'cur-1', name: 'Vicryl', category: 'suture', size: '4-0', quantity: 4 },
    suggestedItem: { id: 'sug-1', name: 'Monocryl', category: 'suture', size: '5-0', quantity: 3 },
    patternType: 'consistent_substitute',
    confidencePercent: 100,
    estimatedTimeSavedMinutes: 4,
    lastCaseDate: '2026-02-07',
  },
  {
    id: 'sug-002',
    procedureName: 'Total Knee Arthroplasty',
    cptCode: '27447',
    caseCount: 12,
    currentItem: { id: 'cur-2', name: 'Autograft Bone Chips', category: 'graft', quantity: 1 },
    suggestedItem: { id: 'sug-2', name: 'None', category: 'graft', quantity: 0 },
    patternType: 'never_used',
    confidencePercent: 92,
    estimatedTimeSavedMinutes: 3,
    lastCaseDate: '2026-02-09',
  },
  {
    id: 'sug-003',
    procedureName: 'Total Hip Arthroplasty',
    cptCode: '27130',
    caseCount: 6,
    currentItem: { id: 'cur-3', name: 'Closed Suction Drain', category: 'consumable', quantity: 2 },
    suggestedItem: { id: 'sug-3', name: 'Closed Suction Drain', category: 'consumable', quantity: 1 },
    patternType: 'quantity_adjust',
    confidencePercent: 83,
    estimatedTimeSavedMinutes: 2,
    lastCaseDate: '2026-02-06',
  },
  {
    id: 'sug-004',
    procedureName: 'Shoulder Arthroscopy',
    cptCode: '29827',
    caseCount: 10,
    currentItem: { id: 'cur-4', name: 'Ethibond', category: 'suture', size: '2-0', quantity: 6 },
    suggestedItem: { id: 'sug-4', name: 'FiberWire', category: 'suture', size: '2-0', quantity: 4 },
    patternType: 'consistent_substitute',
    confidencePercent: 90,
    estimatedTimeSavedMinutes: 5,
    lastCaseDate: '2026-02-08',
  },
  {
    id: 'sug-005',
    procedureName: 'Carpal Tunnel Release',
    cptCode: '64721',
    caseCount: 8,
    currentItem: { id: 'cur-5', name: 'Bovie Tip (Standard)', category: 'instrument', quantity: 1 },
    suggestedItem: { id: 'sug-5', name: 'None', category: 'instrument', quantity: 0 },
    patternType: 'never_used',
    confidencePercent: 100,
    estimatedTimeSavedMinutes: 1,
    lastCaseDate: '2026-02-07',
  },
];
